/*
 * @Author: laipp
 * @Date: 2023-01-31 15:20:08
 * @Description:
 */
import { Quan_ModelNotifyGroup_NotifyEvent } from '@quan/proto-api-client';

export const DEVIS_ID_KEY = 'nanoid';

export const EventMap = {
  [Quan_ModelNotifyGroup_NotifyEvent.NotifyEventContactCountLimit]: '扩容提醒',
  [Quan_ModelNotifyGroup_NotifyEvent.NotifyEventRobotLogout]: '掉线通知',
  [Quan_ModelNotifyGroup_NotifyEvent.NotifyEventRobotBeBan]: '功能受限',
  [Quan_ModelNotifyGroup_NotifyEvent.NotifyEventRobotCancelBan]: '功能解封',
  [Quan_ModelNotifyGroup_NotifyEvent.NotifyEventFriendAddDelay]: '线索积压',
  [Quan_ModelNotifyGroup_NotifyEvent.NotifyEventRobotLoginNeedVerifyQrcode]: '二次验证',
  [Quan_ModelNotifyGroup_NotifyEvent.NotifyEventRecheckMobile]: '微信授权到期通知',
  [Quan_ModelNotifyGroup_NotifyEvent.NotifyEventUserAssignLimitLteTwenty]:
    '活码可用员工剩余20%提醒',
  [Quan_ModelNotifyGroup_NotifyEvent.NotifyEventUserOutOfAppScope]: '账号被移出可见范围通知',
};
